import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative" }
const _hoisted_2 = { class: "flex flex-row gap-6 items-center justify-between py-1" }
const _hoisted_3 = { class: "flex flex-row gap-6 items-center" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "text-xl font-semibold text-black-lp-100" }, "Konversi mata uang", -1)
const _hoisted_5 = { class: "grid gap-6 grid-cols-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectSearchV2 = _resolveComponent("SelectSearchV2")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_Select = _resolveComponent("Select")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_TableV2 = _resolveComponent("TableV2")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_DataWrapper, { class: "w-52" }, {
            default: _withCtx(() => [
              _createVNode(_component_SelectSearchV2, {
                onFilter: _ctx.fetchCountryCurrency,
                isLoading: _ctx.isLoadingCountry,
                options: _ctx.fromCountryListData,
                keyName: "name",
                keyValue: "value",
                placeholder: "Semua kurs awal",
                modelValue: _ctx.kursAwal,
                "onUpdate:modelValue": [
                  _cache[1] || (_cache[1] = ($event: any) => (_ctx.kursAwal = $event)),
                  _ctx.onSelectKursAwal
                ],
                onFocus: _cache[2] || (_cache[2] = () => _ctx.fetchCountryCurrency('')),
                class: "mt-2"
              }, {
                "custom-option": _withCtx(({item}) => [
                  _createVNode("div", null, [
                    _createTextVNode(_toDisplayString(item.nameOnly) + " - ", 1),
                    _createVNode("strong", null, _toDisplayString(item.currency), 1)
                  ])
                ]),
                _: 1
              }, 8, ["onFilter", "isLoading", "options", "modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, { class: "w-52" }, {
            default: _withCtx(() => [
              _createVNode(_component_SelectSearchV2, {
                onFilter: _ctx.fetchCountryCurrency,
                isLoading: _ctx.isLoadingCountry,
                options: _ctx.toCountryListData,
                keyName: "name",
                keyValue: "value",
                placeholder: "Semua kurs tukar",
                modelValue: _ctx.kursTukar,
                "onUpdate:modelValue": [
                  _cache[3] || (_cache[3] = ($event: any) => (_ctx.kursTukar = $event)),
                  _ctx.onSelectKursTukar
                ],
                onFocus: _cache[4] || (_cache[4] = () => _ctx.fetchCountryCurrency('')),
                class: "mt-2"
              }, {
                "custom-option": _withCtx(({item}) => [
                  _createVNode("div", null, [
                    _createTextVNode(_toDisplayString(item.nameOnly) + " - ", 1),
                    _createVNode("strong", null, _toDisplayString(item.currency), 1)
                  ])
                ]),
                _: 1
              }, 8, ["onFilter", "isLoading", "options", "modelValue", "onUpdate:modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, null, {
            default: _withCtx(() => [
              _createVNode(_component_Select, {
                dataSelect: _ctx.statusData,
                onOpenSelect: _ctx.onOpenStatusSelect,
                onCloseSelect: _ctx.onCloseStatusSelect,
                onChooseSelect: _ctx.onSelectStatus,
                value: _ctx.statusName,
                isOpenMenu: _ctx.statusSelect,
                class: "w-full z-20 mt-2"
              }, null, 8, ["dataSelect", "onOpenSelect", "onCloseSelect", "onChooseSelect", "value", "isOpenMenu"])
            ]),
            _: 1
          })
        ])
      ]),
      (_ctx.isCreateAble)
        ? (_openBlock(), _createBlock(_component_LpButton, {
            key: 0,
            title: "Buat Konversi",
            onClick: _ctx.toPageAdd,
            textColor: "white",
            color: "red-lp-2400"
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.isError && !_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 0,
          errorType: _ctx.errorCause,
          onTryAgain: _ctx.onRequest
        }, null, 8, ["errorType", "onTryAgain"]))
      : (
      _ctx.exchangeData.length === 0 &&
        !_ctx.isLoading &&
        _ctx.pagination.page === 1 &&
        _ctx.firstRequest &&
        !_ctx.isError &&
        !_ctx.kursAwal &&
        !_ctx.kursTukar &&
        _ctx.statusName === ''
      )
        ? (_openBlock(), _createBlock(_component_EmptyState, {
            key: 1,
            data: "data Exchange Rate"
          }))
        : (_openBlock(), _createBlock(_component_TableV2, {
            key: 2,
            pagination: _ctx.pagination,
            "onUpdate:pagination": _cache[5] || (_cache[5] = ($event: any) => (_ctx.pagination = $event)),
            loading: _ctx.isLoading,
            columns: _ctx.columns,
            data: _ctx.exchangeData,
            class: "my-2",
            onRequest: _ctx.onRequest,
            onClick: _ctx.onClickRow,
            isDetailAble: _ctx.isDetailAble
          }, null, 8, ["pagination", "loading", "columns", "data", "onRequest", "onClick", "isDetailAble"]))
  ]))
}